import { render } from "./AddLogbook.vue?vue&type=template&id=4a7e4a9a&scoped=true"
import script from "./AddLogbook.vue?vue&type=script&lang=js"
export * from "./AddLogbook.vue?vue&type=script&lang=js"

import "./AddLogbook.vue?vue&type=style&index=0&id=4a7e4a9a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a7e4a9a"]])

export default __exports__